var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 88 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 0C12 0 0 32 0 32C0 32 12 64 44 64C76 64 88 32 88 32C88 32 76 0 44 0ZM44 8C65.104 8 75.7784 25.0684 79.2344 31.9844C75.7744 38.8524 65.02 56 44 56C22.896 56 12.2216 38.9316 8.76562 32.0156C12.2296 25.1476 22.98 8 44 8ZM44 16C35.164 16 28 23.164 28 32C28 40.836 35.164 48 44 48C52.836 48 60 40.836 60 32C60 23.164 52.836 16 44 16ZM44 24C48.42 24 52 27.58 52 32C52 36.42 48.42 40 44 40C39.58 40 36 36.42 36 32C36 27.58 39.58 24 44 24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.65070b74518714d0d19771e49e3e0996.svg";
export { ForwardRef as ReactComponent };